import { z } from "zod";

export const genreNestedSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type GenreNestedType = z.infer<typeof genreNestedSchema>;
